let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2A55e"), load("e9Lfg"), load("bZeLH"), load("3kHns"), load("3JzPO"), load("6qah4"), load("aIuOE")]).then(() => parcelRequire('56n4X'));